import React, { FC } from "react";
import { IUserTrainingCourseSectionSummary } from "src/@types/ImpiricaPlatformApi";
import { ClientTrainingTOCSectionCompletion } from "./ClientTrainingTOCSectionCompletion";
import { Duration } from "./Duration";
import styles from "./ClientTrainingTOCSection.module.css";

type ClientTrainingTOCSectionProps = {
	section: IUserTrainingCourseSectionSummary;
};

export const ClientTrainingTOCSection: FC<ClientTrainingTOCSectionProps> = ({
	section,
}) => {
	return (
		<ul className={styles.menuItem}>
			<li>
				<a href={`#${section.name}`}>{section.name}</a>
			</li>
			{section.videos &&
				section.videos.map((video) => (
					<li key={video.name} className={styles.videoDetails}>
						<a href={`#${video.id}`}>
							<p className={styles.name}>{video.name}</p>
						</a>
						<p className={styles.durationCompletion}>
							<Duration duration={video.duration} />
							<ClientTrainingTOCSectionCompletion complete={video.complete} />
						</p>
					</li>
				))}
		</ul>
	);
};
